import useSWR from "swr";
import { SalesCrmStats_Api, SalesLeads_Api } from "../../../../api/endpoints";
import { fetcher } from "../../../../services/fetcher";
import {
  CRM_OVERDUE_FOLLOWUPS_URL,
  CRM_TODAY_FOLLOWUPS_URL,
} from "./salesDashboard.constants";
import mapCrmStatsDashboard from "./mapCrmStatsDashboard";
import { SWR_OPTS, toRows } from "./salesDashboard.utils";

const RECENT_LEADS_URL = `${SalesLeads_Api}?ordering=-created_on&page_size=5`;

export default function useSalesDashboardData() {
  const { data: statsData, isLoading: isStatsLoading, mutate: mutateStats } = useSWR(
    SalesCrmStats_Api,
    fetcher,
    SWR_OPTS
  );
  const { data: recentLeadsData, isLoading: isRecentLeadsLoading } = useSWR(
    RECENT_LEADS_URL,
    fetcher,
    SWR_OPTS
  );
  const {
    data: todayFollowupsData,
    isLoading: isTodayFollowupsLoading,
    mutate: mutateTodayFollowups,
  } = useSWR(CRM_TODAY_FOLLOWUPS_URL, fetcher, SWR_OPTS);
  const {
    data: overdueFollowupsData,
    isLoading: isOverdueFollowupsLoading,
    mutate: mutateOverdueFollowups,
  } = useSWR(CRM_OVERDUE_FOLLOWUPS_URL, fetcher, SWR_OPTS);

  const overdueFollowups = toRows(overdueFollowupsData);

  return {
    ...mapCrmStatsDashboard(statsData, isStatsLoading),
    recentLeads: toRows(recentLeadsData),
    isRecentLeadsLoading,
    todayFollowups: toRows(todayFollowupsData),
    isTodayFollowupsLoading,
    overdueFollowups,
    overdueFollowupsCount: Number(overdueFollowupsData?.count) || overdueFollowups.length,
    isOverdueFollowupsLoading,
    revalidateFollowups: () =>
      Promise.all([mutateTodayFollowups(), mutateOverdueFollowups(), mutateStats()]),
  };
}
